<app-modal-wrapper [staticHeight]='true' [modal]='modal'>
  <app-page-header [title]='"Перевод зарплаты/пенсии"' [backBtn]="false" [closeModalBtn]="false"></app-page-header>

  <div class="salary-transfer__content">
    <ion-button class="salary-transfer__button button block white shadow" mode='ios' expand='block'
                (click)='chooseSalaryOrPension("salary")'>
      Перевести зарплату
    </ion-button>
    <ion-button class="salary-transfer__button button block white shadow" mode='ios' expand='block'
      (click)='chooseSalaryOrPension("pension")'>
      Перевести пенсию
    </ion-button>
  </div>
</app-modal-wrapper>
